import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { perlickConstant } from "config/Perlick.Constant";
import {
  IOrderListRequest,
  IOrderListResponse,
} from "interfaces/ClientInterface/PerlickClientInterface/IOrder";

export interface ICHOrderDetails {
  OrderActivePageNumber: number;
  orderResponseList: IOrderListResponse[];
  orderId: number;
  orderStatus: boolean;
  orderStatusValue: number;
  orderList: IOrderListRequest;
  orderListTime: string;
  orderTotalPage: number;
}

const initialState: ICHOrderDetails = {
  OrderActivePageNumber: perlickConstant.DefaultPageIndex,
  orderResponseList: [],
  orderId: 0,
  orderStatus: false,
  orderStatusValue: 0,
  orderList: {
    SalesRepId: "",
    OrderStartDate: "",
    OrderEndDate: "",
    OrderNum: "",
    PageNo: 1,
    Rows: 10,
    CustID: "",
    CalculatedOrderStatus: "",
    PONo: "",
    FromOrderDate: "",
    ToOrderDate: "",
    OrderStatus: "",
    OrderNoFrom: "",
    OrderNoTo: "",
    OrderAmountFrom: "",
    OrderAmountTo: "",
    OrderName: "",
    JobName: "",
    CustomerName: "",
    ShipToName: "",
    ShipToAddress: "",
    NeedByDateFrom: "",
    NeedByDateTo: "",
    SerialNumber: "",
    filtersList: [],
    Refresh: false,
    startDate: "",
    endDate: "",
  },
  orderListTime: "",
  orderTotalPage: 0,
};

export const chorderSlice = createSlice({
  name: "chOrder",
  initialState,
  reducers: {
    getOrderId: (state, action: PayloadAction<number>) => {
      state.orderId = action.payload;
    },
    getCHOpenStatusModel: (state, action: PayloadAction<number>) => {
      state.orderStatusValue = action.payload;
    },
    getOrderModelOpen: (state, action: PayloadAction<boolean>) => {
      state.orderStatus = action.payload;
    },
    getOrderList: (state, action: PayloadAction<IOrderListResponse[]>) => {
      state.orderResponseList = action.payload;
    },
    getOrderRefreshTime: (state, action: PayloadAction<string>) => {
      state.orderListTime = action.payload;
    },
    getOrderTotalPage: (state, action: PayloadAction<number>) => {
      state.orderTotalPage = action.payload;
    },
    getCHOrderPageNumber: (state, action: PayloadAction<number>) => {
      state.OrderActivePageNumber = action.payload;
    },
  },
});

export const {
  getOrderId,
  getCHOpenStatusModel,
  getOrderModelOpen,
  getOrderList,
  getOrderRefreshTime,
  getOrderTotalPage,
  getCHOrderPageNumber,
} = chorderSlice.actions;

export default chorderSlice.reducer;
